import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useAppDispatch } from '../../hooks'
import { getMamorioImageSrc } from '../../helpers/CommonMamorioHelper'
import { getTeamMamorio } from '../../modules/Mamorio'
import NotFound from '../../containers/NotFound/NotFound'
import Loading from '../common/Loading'
import { HeaderNavi } from '../navigation'
import EditMamorioModal from '../settings/modal/EditMamorioModal'
import './MamorioEditPage.css'

type Params = {
  major_minor: string
}

const MamorioEditPage = () => {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const { major_minor } = useParams<Params>()
  const [mamorio, setMamorio] = useState<IMamorio | undefined>(undefined)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchMamorio = async () => {
      try {
        const response = await dispatch(getTeamMamorio({
          mamorio_id: major_minor,
        })).unwrap()
        setMamorio(response.mamorio)
      } catch (error) {
        console.error('Failed to fetch mamorio:', error)
        setMamorio(undefined)
      } finally {
        setIsLoading(false)
      }
    }

    fetchMamorio()
  }, [dispatch, major_minor])

  if (isLoading) {
    return (
      <div className="content">
        <HeaderNavi />
        <Loading show />
      </div>
    )
  }

  if (!mamorio) {
    return (
      <div className="content">
        <HeaderNavi />
        <NotFound />
      </div>
    )
  }

  const goBackToDetail = () => {
    history.push(`/mamorios/${mamorio.major}-${mamorio.minor}`)
  }

  return (
    <>
      <HeaderNavi />
      <main className="mamorio-edit-page" data-testid="mamorio-edit-page">
        <div className="mamorio-edit-page__container">
          <header className="mamorio-edit-page__header">
            <h1>MAMORIO編集</h1>
            <button type="button" onClick={goBackToDetail}>
              戻る
            </button>
          </header>
          <div className="mamorio-edit-page__summary">
            <img src={getMamorioImageSrc(mamorio)} alt="mamorio" />
            <div>
              <div className="mamorio-edit-page__name">{mamorio.name}</div>
              <div className="mamorio-edit-page__major-minor">
                {`${mamorio.major}-${mamorio.minor}`}
              </div>
            </div>
          </div>
          <section className="mamorio-edit-page__form">
            <EditMamorioModal
              modalProps={{
                title: 'MAMORIO編集',
                mamorio,
                onActionConfirmed: () => {},
              }}
              closeModalFunction={goBackToDetail}
            />
          </section>
        </div>
      </main>
    </>
  )
}

export default MamorioEditPage
